// extracted by mini-css-extract-plugin
export default {"StickyTable":"StickyTable_StickyTable__9un69"};